// src/pages/WebinarThanksPage.tsx
// Post-registration/payment confirmation at /webinar/thanks. Razorpay payment
// links redirect here with razorpay_payment_id in the query string; we report
// it to /api/webinar-confirm (best-effort) and show the WhatsApp group CTA.
import React, { useEffect } from 'react';
import { WEBINAR } from './webinarConfig';

const WebinarThanksPage: React.FC = () => {
  useEffect(() => {
    const params = new URLSearchParams(window.location.search);
    const paymentId = params.get('razorpay_payment_id');
    const regId = localStorage.getItem('webinar_reg_id');
    if (!paymentId || !regId) return;
    const apiUrl = process.env.REACT_APP_API_URL || '';
    fetch(`${apiUrl}/api/webinar-confirm`, {
      method: 'POST',
      headers: { 'Content-Type': 'application/json' },
      body: JSON.stringify({ registration_id: regId, razorpay_payment_id: paymentId }),
    }).catch(() => { /* best-effort; reconcile in Razorpay dashboard */ });
  }, []);

  return (
    <div className="min-h-screen flex flex-col" style={{ background: '#fefae8', color: '#1a1a2e', fontFamily: "'Inter', system-ui, sans-serif" }}>
      <nav className="border-b" style={{ borderColor: '#1a1a2e14' }}>
        <div className="max-w-6xl mx-auto px-6 h-16 flex items-center">
          <a href="/" className="flex items-center gap-2.5">
            <img src="/cubemate-logo.png" alt="Cubemate" className="w-8 h-8 rounded-lg" />
            <span className="font-bold tracking-tight text-lg">Cubemate</span>
          </a>
        </div>
      </nav>

      <main className="flex-1 grid place-items-center px-6 py-16">
        <div className="max-w-lg w-full text-center rounded-3xl p-10 bg-white border" style={{ borderColor: '#1a1a2e15', boxShadow: '0 8px 24px -10px rgba(26,26,46,.08)' }}>
          <div className="text-5xl mb-4">🎉</div>
          <h1 className="text-3xl font-black tracking-tight mb-3">You're in!</h1>
          <p className="text-lg leading-relaxed mb-2" style={{ color: '#40405a' }}>
            Your seat for <strong>"{WEBINAR.title}"</strong> is reserved.
          </p>
          <p className="text-base mb-8" style={{ color: '#6b6b85' }}>
            📅 {WEBINAR.dateDisplay}
          </p>

          {WEBINAR.whatsappLink ? (
            <>
              <a href={WEBINAR.whatsappLink} target="_blank" rel="noopener noreferrer"
                className="block w-full py-4 font-bold rounded-full text-white transition hover:opacity-90 shadow-lg"
                style={{ background: '#25D366' }}>
                Join the WhatsApp group →
              </a>
              <p className="text-sm mt-4" style={{ color: '#6b6b85' }}>
                ⚠️ This step matters — the joining link and reminders are shared in the group.
              </p>
            </>
          ) : (
            <p className="text-base font-semibold rounded-xl px-4 py-3" style={{ background: '#fff5d1', color: '#40405a' }}>
              Watch your email &amp; WhatsApp — the joining link and group invite are on their way.
            </p>
          )}
        </div>
      </main>

      <footer className="py-8 text-center text-xs" style={{ color: '#6b6b85' }}>
        © 2026 Cubemate. Made in India.
      </footer>
    </div>
  );
};

export default WebinarThanksPage;
